import React from "react";
import { func } from "prop-types";
import Button from "pages/_components/Button";

const FilterTags = ({ openSideBarFilters }) => (
    <div className="tags-filter filters-toolbar">
        <Button
            image="images/figma/icon/filter.svg"
            onClick={openSideBarFilters}
            label="global.filter"
            className="open-filters"
            block={false}
            bsstyle="link"
        />
    </div>
);

FilterTags.propTypes = {
    openSideBarFilters: func.isRequired,
};

export default FilterTags;
